<template lang="html">
    <div class="flex-col editApp-container">
        <div class="breadCrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>{{$t('message.users')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('message.subordinate')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="flex-col editApp-body-container verifone-panel">
            <div class="flex-col edit-body">
                <div class="flex-row edit-group-item" >
                    <div class="div-tip">{{$t('message.appBaic')}}</div>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.name')}}</div>
                    <el-input class="double-input" v-model="firstName" :placeholder="$t('message.firstName')" maxLength="50"></el-input>
                    <el-input class="double-input" v-model="lastName" :placeholder="$t('message.lastName')" maxLength="50"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.accountEmail')}}</div>
                    <el-input class="input-margin" v-model="username" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                </div>
                <!-- <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar" v-show=" id === 'nil' ">*</span>{{$t('message.passwordLogin')}}</div>
                    <el-input class="input-margin" type="password" v-model="password" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                </div>
                <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar" v-show=" id === 'nil' ">*</span>{{$t('message.confirmPassword')}}</div>
                    <el-input class="input-margin" type="password" v-model="confirmPassword" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                </div> -->
                <!-- <div class="flex-row edit-app-item">
                    <div class="item-name"><span class="redStar">*</span>{{$t('message.email')}}</div>
                    <el-input class="input-margin" v-model="email" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                </div> -->
                <div class="flex-row edit-app-item" v-show="resetShow">
                    <div class="item-name">{{$t('message.resetPassword')}}</div>
                    <el-button type="danger" plain icon="el-icon-refresh" class="verifone-btn" style="margin-right: 10px;" @click="handleReset">{{$t('message.reset')}}</el-button>
                </div>

                <div class="flex-row edit-group-item" >
                    <div class="div-tip">{{$t('message.permission')}}</div>
                </div>
                <div class="flex-row edit-checkbox-item">
                    <div class="double-checkbox-item">
                        <el-checkbox :indeterminate="isIndeterminate1" v-model="checkAll1" @change="handleCheckAllChange1">{{$t('message.selectAll')}}</el-checkbox>
                    </div>
                    <div class="double-checkbox-item query-checkbox">
                        <el-checkbox :indeterminate="isIndeterminate2" v-model="checkAll2" @change="handleCheckAllChange2">{{$t('message.selectAll')}}</el-checkbox>
                    </div>
                </div>
                <div class="flex-row edit-checkbox-item">
                    <div class="double-checkbox-item">
                        <el-checkbox-group class="flex-col" v-model="checkedManage1" @change="handleCheckedCitiesChange1">
                            <el-checkbox v-for="city in manageList" :label="city" :key="city" style="padding: 10px 0;margin-top: 10px">{{city}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="double-checkbox-item query-checkbox">
                        <el-checkbox-group class="flex-col" v-model="checkedManage2" @change="handleCheckedCitiesChange2">
                            <el-checkbox v-for="(city,index ) in manageOpretaList"  :class="{activeCheck:index === 1 ||index === 5

                            }" :label="city" :key="city" style="padding: 10px 0;margin-top: 10px">{{city}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="flex-row footer-contain">
                    <el-button type="primary" plain icon="el-icon-close" class="verifone-btn" style="margin-right: 10px;" @click="backToUser">{{$t('message.cancel')}}</el-button>
                    <el-button type="primary" icon="el-icon-document" class="verifone-btn" @click="handleAdmin">{{$t('message.submit')}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import ElButton from "element-ui/packages/button/src/button"

const manageListId = [10, 20, 30, 40, 50, 70, 80/* ,110//功能暂时隐藏 */ ];
const manageOpretaListId = [11, 31, 41, 51, 71,90 ,100];

export default {
    components: {ElButton},
    data () {
        return  {
            count:0,
            manageList: [this.$t('message.merchantManagement'), this.$t('message.groupManage'), this.$t('message.appManagement'), this.$t('message.terminalManagement'), this.$t('message.downloadManagement'),this.$t('message.alertManagement'), this.$t('message.userManagement')/* ,this.$t('message.functionManage')//功能不需要暂时隐藏 */],
            manageOpretaList: [this.$t('message.merchantQuery'), this.$t('message.appQuery'), this.$t('message.terminalQuery'), this.$t('message.downloadQuery'),  this.$t('message.alertQuery'),this.$t('message.reportCreate'), this.$t('message.reportDownload')],
            checkAll1: false,
            checkAll2: false,
            checkedManage: [],
            checkedManageIdList: [],
            checkedManage2: [],
            checkedManage1: [],
            isIndeterminate1: true,
            isIndeterminate2: true,
            firstName: '',
            lastName: '',
            username: '',
            password: '',
            email: '',
            resetShow: false,
            inputCheck: this.$t('message.inputCheck'),
            modifySuccess: this.$t('message.modifySuccess'),
            passwordCheck: this.$t('message.passwordCheck'),
            confirmPassword: '',
            id: '',
            addSuccess: this.$t('message.addSuccess'),
            rightsMap: {
                10: this.$t('message.merchantManagement'),
                11: this.$t('message.merchantQuery'),
                20: this.$t('message.groupManage'),
                30: this.$t('message.appManagement'),
                31: this.$t('message.appQuery'),
                40: this.$t('message.terminalManagement'),
                41: this.$t('message.terminalQuery'),
                50: this.$t('message.downloadManagement'),
                51: this.$t('message.downloadQuery'),
                70: this.$t('message.alertManagement'),
                71: this.$t('message.alertQuery'),
                80: this.$t('message.userManagement'),
                90: this.$t('message.reportCreate'),
                100: this.$t('message.reportDownload'),
              /*  110:this.$t('message.functionManage')//功能不需要暂时隐藏 */
            }
        }
    },
    mounted() {
        this.init();
    },
  computed:{
    changeData(){
      const {firstName,lastName,username,password,email,rightsMap,manageList,manageOpretaList,checkAll1,checkAll2,checkedManage1,checkedManage2}=this
      return{
        firstName,lastName,username,password,email,rightsMap,manageList,manageOpretaList,checkAll1,checkAll2,checkedManage1,checkedManage2
      }
    }
  },
  watch:{
    changeData: {
      handler(oldVal, newVal) {
        if (oldVal!=newVal && newVal.firstName=="") {
          this.count == 0;
        } else if (newVal == oldVal) {
          this.count == 0;
        }else  {
          this.count++;
        }
      },
      deep: true
    }
  },
    methods:{
        init() {
            this.id = this.$route.params.id;

            if(this.id != 'nil') {
                this.resetShow = true,
                this.queryUser(this.id);
            }else {
                this.resetShow = false;
            }

             
        },
        handleAdmin() {
            if(this.id == 'nil') {
                this.addAdmin();
            }else {
                this.modifyAdmin();
            }
        },
        listTransform: function(arr) {
            let queryArr = arr.map(item => {item = this.rightsMap[item]; return item});

            return queryArr;
        },
      // 退出编辑提示
      backToUser() {
        if(this.count>0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.$router.replace('/adminList');
          })
        }else{
          this.$router.replace('/adminList');
        }
      },
        checkPassword() {

        },
        queryUser(id) {
            let obj = {
                id: id
            }
            this.$axios({
                method: 'post',
                url: "/marketplace/admin/account/detail",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.firstName = response.data.firstName;
                    this.lastName = response.data.lastName;
                    this.username = response.data.username;
                    // this.email = response.data.email;

                    this.setRole(response.data.roleList);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        modifyAdmin() {//this.$route.params.id
            if(!this.checkSubmit()) return;

            this.checkedManageId();
            const that =this;
            let obj = {
                firstName: this.firstName,
                lastName: this.lastName,
                username: this.username,
                // password: this.password,
                // email: this.email,
                roleList: this.checkedManageIdList,
                id: this.id
            };

            this.$axios({
                method: 'post',
                url: "/marketplace/admin/account/edit",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.$message({
                      type: "success",
                      message: that.modifySuccess,
                      duration:'3000',
                    });
                    this.$router.replace('/adminList');
                }

                // this.checkedManage = [];
            }).catch((err) => {
                console.log(err);
            });
        },
        checkSubmit() {
            let that = this;
            if(!this.firstName || !this.lastName) {
                this.$message({
                    type: "error",
                    message: that.inputCheck,
                    duration: '3000',
                });
                return false;
            }
            // if(this.id==='nil') {
            //
            //   if(!this.confirmPassword || !this.password ){
            //     this.$message({
            //       type: "error",
            //       message: that.inputCheck,
            //       duration: '3000',
            //     });
            //     return false;
            //   }
            //
            //   if(this.password !== this.confirmPassword) {
            //     this.$message({
            //       type: "error",
            //       message: that.passwordCheck,
            //       duration: '3000',
            //     });
            //     return false;
            //   }
            // }

            return true;
        },
        checkedManageId(){
            let that = this;

            this.checkedManageIdList = [];

            this.checkedManage1.forEach(item => {
                that.transformId(item, that);
            });

            this.checkedManage2.forEach(item => {
                that.transformId(item, that);
            });
        },
        handleReset() {
            let obj = {
                id: this.id
            };

            this.$axios({
                method: 'post',
                url: "/marketplace/admin/account/resetpwd",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.$message({
                      type: "success",
                      message: that.addSuccess,
                      duration:'3000',
                    });
                    window.history.go(-1);
                }

            }).catch((err) => {
                console.log(err);
            });
        },
        addAdmin(){
            const that =this;
            if(!this.checkSubmit()) return;
            this.checkedManageId();

            let obj = {
                firstName:this.firstName,
                lastName:this.lastName,
                username:this.username,
                // email:this.email,
                roleList:this.checkedManageIdList,
            };

            this.$axios({
                method: 'post',
                url: "/marketplace/admin/account/add",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.$message({
                      type: "success",
                      message: that.addSuccess,
                      duration:'3000',
                    });
                    window.history.go(-1);
                }

            }).catch((err) => {
                console.log(err);
            });
        },
        handleCheckAllChange1(val) {
            this.checkedManage1 = val ? this.listTransform(manageListId) : [];
            this.isIndeterminate1 = false;

            if(val) {
                this.refreshQuery(this.checkedManage1);
            }

        },
        handleCheckedCitiesChange1(value) {
            let checkedCount = value.length;

            this.checkAll1 = checkedCount === manageListId.length;
            this.isIndeterminate1 = checkedCount > 0 && checkedCount < manageListId.length;
            this.refreshQuery(value);
            console.log('handleChecked1');
            console.log(this.checkedManage1);
        },
        handleCheckAllChange2(val) {
            this.checkedManage2 = val ? this.listTransform(manageOpretaListId) : [];
            this.isIndeterminate2 = false;

            if(val) {
                this.refreshManagement(this.checkedManage2);
            }

        },
        handleCheckedCitiesChange2(value) {
            let checkedCount = value.length;
            this.checkAll2 = checkedCount === manageOpretaListId.length;
            this.isIndeterminate2 = checkedCount > 0 && checkedCount < manageOpretaListId.length;
            this.refreshManagement(value);
        },
        refreshStatus(type) {// 0: management 1: query
            if(type == 0) {
                let checkedCount = this.checkedManage1.length;
                this.checkAll1 = checkedCount === manageListId.length;
                this.isIndeterminate1 = checkedCount > 0 && checkedCount < manageListId.length;

                // console.log(this.isIndeterminate1);
                // console.log(this.checkAll1);
                // console.log(this.checkedManage1);
                // console.log(this.checkedManage1.length);
                // console.log(this.manageList);
                // console.log(this.manageList.length);
            }else {
                let checkedCount = this.checkedManage2.length;
                this.checkAll2 = checkedCount === manageOpretaListId.length;
                this.isIndeterminate2 = checkedCount > 0 && checkedCount < manageOpretaListId.length;

                // console.log(this.isIndeterminate2);
                // console.log(this.checkAll2);
                // console.log(this.checkedManage2);
                // console.log(this.checkedManage2.length);
                // console.log(this.this.manageOpretaList);
                // console.log(this.this.manageOpretaList.length);
            }
        },
        refreshQuery(val) {
            let merchantQuery = this.checkedManage2.includes(this.$t('message.merchantQuery')),
                appQuery = this.checkedManage2.includes(this.$t('message.appQuery')),
                terminalQuery = this.checkedManage2.includes(this.$t('message.terminalQuery')),
                downloadQuery = this.checkedManage2.includes(this.$t('message.downloadQuery')),
                alertQuery = this.checkedManage2.includes(this.$t('message.alertQuery')),
                reportCreate = this.checkedManage2.includes(this.$t('message.reportCreate')),
                reportDownload = this.checkedManage2.includes(this.$t('message.reportDownload')),


                merchantManagement = val.includes(this.$t('message.merchantManagement')),
                appManagement = val.includes(this.$t('message.appManagement')),
                terminalManagement = val.includes(this.$t('message.terminalManagement')),
                downloadManagement = val.includes(this.$t('message.downloadManagement')),
                alertManagement = val.includes(this.$t('message.alertManagement'));

            if(merchantManagement && merchantQuery) {
                let merchantIndex = this.checkedManage2.indexOf(this.$t('message.merchantQuery')),
                    checkedCount = this.checkedManage2;
                this.checkedManage2.splice(merchantIndex, 1);
                this.refreshStatus(1);
            }

            if(appManagement && appQuery) {
                let appManagement = this.checkedManage2.indexOf(this.$t('message.appQuery'));
                this.checkedManage2.splice(appManagement, 1);
                this.refreshStatus(1);
            }

            if(terminalManagement && terminalQuery) {
                let terminalManagement = this.checkedManage2.indexOf(this.$t('message.terminalQuery'));
                this.checkedManage2.splice(terminalManagement, 1);
                this.refreshStatus(1);
            }

            if(downloadManagement && downloadQuery) {
                let downloadManagement = this.checkedManage2.indexOf(this.$t('message.downloadQuery'));
                this.checkedManage2.splice(downloadManagement, 1);
                this.refreshStatus(1);
            }

            if(alertManagement && alertQuery) {
                let alertManagement = this.checkedManage2.indexOf(this.$t('message.alertQuery'));
                this.checkedManage2.splice(alertManagement, 1);
                this.refreshStatus(1);
            }

            if(reportCreate) {
                let reportCreate = this.checkedManage2.indexOf(this.$t('message.reportCreate'));
                this.checkedManage2.splice(reportCreate, 1);
                this.refreshStatus(1);
            }
            if(reportDownload) {
                let reportDownload = this.checkedManage2.indexOf(this.$t('message.reportDownload'));
                this.checkedManage2.splice(reportDownload, 1);
                this.refreshStatus(1);
            }
        },
        refreshManagement(val) {
            let merchantQuery = val.includes(this.$t('message.merchantQuery')),
                appQuery = val.includes(this.$t('message.appQuery')),
                terminalQuery = val.includes(this.$t('message.terminalQuery')),
                downloadQuery = val.includes(this.$t('message.downloadQuery')),
                alertQuery = val.includes(this.$t('message.alertQuery')),
                merchantManagement = this.checkedManage1.includes(this.$t('message.merchantManagement')),
                appManagement = this.checkedManage1.includes(this.$t('message.appManagement')),
                terminalManagement = this.checkedManage1.includes(this.$t('message.terminalManagement')),
                downloadManagement = this.checkedManage1.includes(this.$t('message.downloadManagement')),
                alertManagement = this.checkedManage1.includes(this.$t('message.alertManagement'));

            if(merchantQuery && merchantManagement) {
                let merchantIndex = this.checkedManage1.indexOf(this.$t('message.merchantManagement'));
                this.checkedManage1.splice(merchantIndex, 1);
                this.refreshStatus(0);
            }

            if(appQuery && appManagement) {
                let appManagement = this.checkedManage1.indexOf(this.$t('message.appManagement'));
                this.checkedManage1.splice(appManagement, 1);
                this.refreshStatus(0);
            }

            if(terminalQuery && terminalManagement) {
                let terminalManagement = this.checkedManage1.indexOf(this.$t('message.terminalManagement'));
                this.checkedManage1.splice(terminalManagement, 1);
                this.refreshStatus(0);
            }

            if(downloadQuery && downloadManagement) {
                let downloadManagement = this.checkedManage1.indexOf(this.$t('message.downloadManagement'));
                this.checkedManage1.splice(downloadManagement, 1);
                this.refreshStatus(0);
            }

            if(alertQuery && alertManagement) {
                let alertManagement = this.checkedManage1.indexOf(this.$t('message.alertManagement'));
                this.checkedManage1.splice(alertManagement, 1);
                this.refreshStatus(0);
            }
        },
        realLength(str) {
            return str.replace(/[^\x00-\xff]/g,"**").length;
        },
        checkInput(obj,num) {
            if(this.realLength(obj)>num){
                obj.slice(0, num);
            }
        },
        setRole(roleList) {
            let that = this;

            roleList.forEach(item => {
                switch (item) {
                    case 10:
                        that.checkedManage1.push(that.$t('message.merchantManagement'));
                        break;
                    case 11:
                        that.checkedManage2.push(that.$t('message.merchantQuery'));
                        break;
                    case 20:
                        that.checkedManage1.push(that.$t('message.groupManage'));
                        break;
                    case 30:
                        that.checkedManage1.push(that.$t('message.appManagement'));
                        break;
                    case 31:
                        that.checkedManage2.push(that.$t('message.appQuery'));
                        break;
                    case 40:
                        that.checkedManage1.push(that.$t('message.terminalManagement'));
                        break;
                    case 41:
                        that.checkedManage2.push(that.$t('message.terminalQuery'));
                        break;
                    case 50:
                        that.checkedManage1.push(that.$t('message.downloadManagement'));
                        break;
                    case 51:
                        that.checkedManage2.push(that.$t('message.downloadQuery'));
                        break;
                    case 70:
                        that.checkedManage1.push(that.$t('message.alertManagement'));
                        break;
                    case 71:
                        that.checkedManage2.push(that.$t('message.alertQuery'));
                        break;
                    case 80:
                        that.checkedManage1.push(that.$t('message.userManagement'));
                        break;
                    case 90:
                        that.checkedManage2.push(that.$t('message.reportCreate'));
                        break;
                    case 100:
                        that.checkedManage2.push(that.$t('message.reportDownload'));
                        break;
                /*    case 110://功能暂时隐藏
                        that.checkedManage1.push(that.$t('message.functionManage'));
                        break; */
                    default:
                }
            });
        },
        transformId(item, that) {
            switch (item) {
                case that.$t('message.merchantManagement'):
                    that.checkedManageIdList.push(10);
                    break;
                case that.$t('message.groupManage'):
                    that.checkedManageIdList.push(20);
                    break;
                case that.$t('message.appManagement'):
                    that.checkedManageIdList.push(30);
                    break;
                case that.$t('message.terminalManagement'):
                    that.checkedManageIdList.push(40);
                    break;
                case that.$t('message.downloadManagement'):
                    that.checkedManageIdList.push(50);
                    break;
                case that.$t('message.alertManagement'):
                    that.checkedManageIdList.push(70);
                    break;
                case that.$t('message.merchantQuery'):
                    that.checkedManageIdList.push(11);
                    break;
                case that.$t('message.appQuery'):
                    that.checkedManageIdList.push(31);
                    break;
                case that.$t('message.terminalQuery'):
                    that.checkedManageIdList.push(41);
                    break;
                case that.$t('message.downloadQuery'):
                    that.checkedManageIdList.push(51);
                    break;
                case that.$t('message.alertQuery'):
                    that.checkedManageIdList.push(71);
                    break;
                case that.$t('message.userManagement'):
                    that.checkedManageIdList.push(80);
                    break;
                case that.$t('message.reportCreate'):
                    that.checkedManageIdList.push(90);
                    break;
                case that.$t('message.reportDownload'):
                    that.checkedManageIdList.push(100);
                    break;
               /* case that.$t('message.functionManage')://功能暂时隐藏
                    that.checkedManageIdList.push(110);
                    break; */
                default:

            }
        }
    },
}

</script>

<style scoped lang="css">
.activeCheck {
    margin-top: 56px!important;
}
.editApp-container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    width: 100%;
    font-family: 'Arial';
    padding: 0 0 10px 0;
}
.editApp-body-container {
    padding:0 30px 0 30px;
    width:100%;
}
.redStar {
    color: red;
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
}
.title {
    padding-left:0;
}
.avatar-uploader,.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader,.el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.avatar {
    width: 100px;
    height: 100px;
    display: block;
}
.edit-body {
    width: 100%;
    line-height: 20px;
    text-align: center;
    /* box-shadow: 1px 1px 1px 1px rgba(170, 170, 170, 1);
    border: 1px solid rgba(255, 255, 255, 0); */
    background: #fff;
    padding: 20px 35px 20px 100px;
}
.app-file-container {
    /*border-bottom:1px solid #BBBBBB;*/
}
.app-message-container {
    padding:10px 0;
}
.left-app-message-container,.right-app-message-container{
    flex: 1;
    padding-right: 30px;
}
.right-app-message-container {
    justify-content: space-between;
    padding-left: 30px;
}
.edit-app-item {
    padding: 8px 0;
    align-items: center;
}
.upload-demo {
    align-items: center;
}
.app-div-name {
    line-height: 26px;
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    text-align: left;
}
.item-name {
    width: 200px;
    font-family: 'Arial';
    font-size: 14px;
    text-align: right;
    margin-right: 10px;
}
.div-tip {
    width: 200px;
    font-family: 'Arial';
    font-size: 14px;
    text-align: left;
    margin-right: 10px;
}
.long-item-name {
    width: 220px;
    font-family: 'Arial';
    font-size: 14px;
    text-align: left;
}
.el-input,.el-textarea{
    width: 16vw;
}
.save-app-btn {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    background-color: #58D56D;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: center;
    font-family: Microsoft Yahei;
    border: 1px solid rgba(187, 187, 187, 1);
}
.footer-contain {
    justify-content: flex-end;
}
.input-margin {
    margin-right: 20px;
    width: 488px!important;
}
.doubleSelect {
    width: 200px!important;
    margin-right: 10px;
}
.double-item-name {
    width: 80px;
    font-size: 14px;
}
.double-input {
    width: 200px!important;
    margin-right: 10px;
}
.edit-group-item {
    padding:0px 0 20px 0;
    font-size: 18px;
    font-weight: bold;
}
.blue-item-name {
    color: #4eb4dd;
    padding: 50px 0 30px 100px;
}
.edit-group-item :first-child{
    margin-top: 30px;
}
.edit-checkbox-item {
    padding-left: 150px;
}
.el-checkbox+.el-checkbox {
    margin-left: 0!important;
}
.double-checkbox-item {
    width: 300px;
    text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/page/AdminAdd.vue